import { render, staticRenderFns } from "./AprovarAtaDialog.vue?vue&type=template&id=3165684a&scoped=true"
import script from "./AprovarAtaDialog.vue?vue&type=script&lang=js"
export * from "./AprovarAtaDialog.vue?vue&type=script&lang=js"
import style0 from "./AprovarAtaDialog.vue?vue&type=style&index=0&id=3165684a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165684a",
  null
  
)

export default component.exports